/**
 * The decision on a case closed as suspicious (LFPIORPI art. 18 fr. VI, S-32): which case it is, whether
 * its 24 hours are up, and whether the form is complete enough to send. The server decides everything
 * else (who may decide, that a decision not to file is never the closer's).
 */
import { isMfaCode } from './mfaApproval';
import type { AvisoDecision, SuspicionClock } from '../services/suspicionAvisos.service';

const REFERENCE_MIN = 3;
const REASON_MIN = 10;

export function sourceLabel(kind: SuspicionClock['source_kind']): string {
  return kind === 'monitoring_alert'
    ? 'Monitoring alert closed as suspicious'
    : 'Sanctions match confirmed';
}

/** The 24 hours are up (counted by the server from the moment the case was closed). */
export function isOverdue(clock: Pick<SuspicionClock, 'hours_open' | 'due_hours' | 'decision'>): boolean {
  return clock.decision === null && clock.hours_open >= clock.due_hours;
}

export function hoursLeft(clock: Pick<SuspicionClock, 'hours_open' | 'due_hours'>): number {
  return Math.max(0, clock.due_hours - clock.hours_open);
}

/** When the 24 hours end: counted from the moment the case was closed. */
export function dueAt(clock: Pick<SuspicionClock, 'started_at' | 'due_hours'>): Date {
  return new Date(new Date(clock.started_at).getTime() + clock.due_hours * 3_600_000);
}

/** A decision not to file is never the one of the person who closed the case (the server refuses it). */
export function mayDecideNotFiled(clock: Pick<SuspicionClock, 'started_by'>, userId: string | null): boolean {
  return userId === null || clock.started_by !== userId;
}

/** The form can be sent: a decision chosen (none is chosen for the officer), filed needs the aviso's
 *  reference, not filed needs the reason, both a code. */
export function canSend(input: {
  decision: AvisoDecision | null;
  reference: string;
  reason: string;
  code: string;
}): boolean {
  if (input.decision === null) return false;
  const detail =
    input.decision === 'filed'
      ? input.reference.trim().length >= REFERENCE_MIN
      : input.reason.trim().length >= REASON_MIN;
  return detail && isMfaCode(input.code.trim());
}
